import { Card, Text, Link, Heading } from "@amzn/storm-ui";
import React, { memo } from "react";
import styled from "styled-components";

const ErrorLayout = memo(styled("div")`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing.xxlarge.default};
    background: ${({ theme }) => theme.color.gray[50]};
    & > div {
        max-width: 70ch;
    }
`);

const ErrorCard = memo(styled(Card)`
    text-align: center;
    padding: ${({ theme }) => theme.spacing.large.default};
`);

interface MarketingAccessErrorProps {
    className?: string;
}

export const MarketingAccessError: React.FC<MarketingAccessErrorProps> = memo(
    ({ className }): JSX.Element => (
        <ErrorLayout className={className}>
            <ErrorCard role="alert" aria-live="polite">
                <Heading renderAs="h2">Access Denied</Heading>
                <Text withMargin>
                    You don't have permission to view marketing content. Please
                    request access.
                </Text>
                <Link
                    href="https://sim.amazon.com/issues/create?template=a43d5f4d-d708-41c0-9c92-da3e0d703ca9"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Request Marketing Narrative Content Access"
                >
                    Request Marketing Narrative Content Access
                </Link>
            </ErrorCard>
        </ErrorLayout>
    ),
);

MarketingAccessError.displayName = "MarketingAccessError";
